export const baseSelectionFieldNames = ['data', 'priority', 'date']
